import { defineMessages, IntlFormatters } from "react-intl";
import { IPlan } from "../types";

const testModerationCategoriesMessages: {[prop: string]: { id: string }} = defineMessages({
    "non-infringement": {
        id: "testModeration.categories.non-infringement",
    },
    "not-redundant": {
        id: "testModeration.categories.not-redundant",
    },
    cover: {
        id: "testModeration.categories.cover",
    },
    spelling: {
        id: "testModeration.categories.spelling",
    },
    "evaluable-description": {
        id: "testModeration.categories.evaluable-description",
    },
    "score-misprint": {
        id: "testModeration.categories.score-misprint",
    },
    "score-layout": {
        id: "testModeration.categories.score-layout",
    },
    pedagogy: {
        id: "testModeration.categories.pedagogy",
    },
    properties: {
        id: "testModeration.categories.properties",
    },
    level: {
        id: "testModeration.categories.level",
    },
});
export const testModerationCategoriesList = [
    "non-infringement",
    "not-redundant",
    "cover",
    "spelling",
    "evaluable-description",
    "score-misprint",
    "score-layout",
    "pedagogy",
    "properties",
    "level",
];

export const testModerationCategories = (fm: IntlFormatters["formatMessage"]) =>
    testModerationCategoriesList.map(category => fm(testModerationCategoriesMessages[category]));

export const testModerationRequirementsList = ["cover", "update", "title", "description", "properties"];
export type RequirementTypes = "cover" | "update" | "title" | "description" | "properties";

const testModerationRequirementsMessages: {[prop: string]: { id: string }} = defineMessages({
    cover: {
        id: "testModeration.requirements.cover",
    },
    update: {
        id: "testModeration.requirements.update",
    },
    title: {
        id: "testModeration.requirements.title",
    },
    description: {
        id: "testModeration.requirements.description",
    },
    properties: {
        id: "testModeration.requirements.properties",
    },
});

export const testModerationRequirements = (fm: IntlFormatters["formatMessage"]) =>
    testModerationRequirementsList.map(el => ({
        value: el,
        message: fm(testModerationRequirementsMessages[el]),
    }));

const requiredPropertiesList = ["clef", "keySignature", "scale"];

const requiredPropertiesMessages: {[prop: string]: { id: string }} = defineMessages({
    clef: {
        id: "meta.clef",
    },
    keySignature: {
        id: "meta.key",
    },
    scale: {
        id: "meta.scale",
    },
});

export const requiredProperties = (fm: IntlFormatters["formatMessage"]) =>
    requiredPropertiesList.map(el => ({
        value: el,
        message: fm(requiredPropertiesMessages[el]),
    }));

const melodyTasks = ["barSorting2", "melodyTable", "tonesetStaff", "solfaName", "piano"];

export const getTestPublishable = (plan: IPlan) => {
    let hasMelodyExercise = plan.tasks.filter(({ type }) => melodyTasks.indexOf(type) !== -1).length > 0;

    const status = {
        cover: !!plan.cover || plan.meta.opus.planType === "exercise",
        update: plan.modified! <= plan.published! && plan.sharable && plan.metaDone,
        clef: !hasMelodyExercise || !!plan.meta.pitch.clef,
        keySignature: !hasMelodyExercise || plan.meta.pitch.key,
        scale: !hasMelodyExercise || plan.meta.pitch.scale,
        title:
            Object.values(plan.name).filter(title => {
                return title.indexOf("...") !== -1;
            }).length === 0,
        description:
            Math.max.apply(
                null,
                Object.values(plan.description).map(description => description.length)
            ) >= 20,
        properties: false,
    };
    status.properties = !!status.clef && !!status.keySignature && !!status.scale;
    const isPublishable = status.cover && status.update && status.properties && status.title && status.description;

    return {
        status,
        isPublishable,
    };
};

export const getUsername = (id: string, usernames: { _id: string, username: string }[]) => {
    let username;
    usernames.forEach(user => {
        if (user._id === id) username = user.username;
    });
    return username;
};